export default "__VITE_ASSET__B2dgq$$X__"